module.exports = __webpack_public_path__ + "static/media/grid2.300f67a8.svg";